import Vue from 'vue'

import Twinkle from '@/components';
import Auth from '@/components/core/Auth'
import ElementUI from 'element-ui'
import NProgress from 'nprogress'
import App from './App.vue'
import router, { addRoleMenus } from './router'
import store from './store'
import i18n from '@/lang'

import 'element-ui/lib/theme-chalk/index.css'
import 'nprogress/nprogress.css'
import 'babel-polyfill'

import vueBus from 'vue-bus'
Vue.use(vueBus);





const errorHandler = (error, vm) => {
  console.error('抛出全局异常');
  console.error(vm);
  console.error(error);

}
Vue.config.productionTip = false;
// Vue.config.errorHandler = errorHandler;
Vue.use(ElementUI, {
  size: 'mini',
  zIndex: 3000,
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(Twinkle)

NProgress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
  if (['/', '/scm', '/forgetpwd', '/encrypt'].indexOf(to.path) === -1 && !Auth.getToken()) {
    {
      ElementUI.Message.error("登陆信息无效或已过期,请重新登陆");
      next('/scm')
    }
  } else {
    window.document.title = to.meta.title || '正在加载..'
    next()
  }
})



const vue = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

window["Vue"] = vue;

if (Auth.getToken()) {
  vue.$signalr.Init();
  addRoleMenus();
}

